var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['burger-btn', { 'is-open': _vm.mobileNavOpen }],on:{"click":function($event){return _vm.toggle()}}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }